import 'css-chunksrc/client/pages/documentsPage/reportsPage/loader/report/styles.scss';export default {
  "report": "_report_16m2n_1"
};